import appIcon from '../Assets/app.png'


const Images = {
    appIcon:appIcon
}

export default Images;